(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketingTrackerNew.Events.EventView.DetailsV2",
                {
                    url: "/DetailsV2",
                    component: "eventDetailsV2",
                    PageTitle: "Event Details | Marketing Tracker"
                });
        }
    ]);

    app.component("eventDetailsV2",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Events/EventView/EventDetailsV2/event-details-v2-template.html",
            controller: eventDetailsV2Controller
        });

    eventDetailsV2Controller.$inject = ["figToaster", "moment", "marketingTrackerEventBuyingUnitApi", "marketingTrackerEventApi", "marketingTrackerEventGroupApi", "marketingTrackerEventResponderApi", "$mdDialog", "$q", "$stateParams", "$timeout", "eventPerformanceService", "marketingTrackerRMEApi", "amplitudeService", "$filter", "rmeCampaignStartDate", "marketingTrackerSalesTrackerInputApi", "permissionService"];
    function eventDetailsV2Controller(figToaster, moment, marketingTrackerEventBuyingUnitApi, marketingTrackerEventApi, marketingTrackerEventGroupApi, marketingTrackerEventResponderApi, $mdDialog, $q, $stateParams, $timeout, eventPerformanceService, marketingTrackerRMEApi, amplitudeService, $filter, rmeCampaignStartDate, marketingTrackerSalesTrackerInputApi, permissionService) {

        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isUploading: false,
                    loadingData: true,
                    loadingPerformance: false,
                    loadingEventTitleCard: false,
                    loadingEventOverview: false,
                    editingEventTitleCard: false,
                    editingEventOverview: false,
                    showRmeApiSection: false,
                    refreshingRmeData: false,
                    isDeletingList: false
                },
                buyingUnitInsights: {
                    Responders: [],
                    InsuranceClosedTotal: 0,
                    AumClosedTotal: 0,
                    InsuranceClosedCount: 0,
                    AumClosedCount: 0
                },
                rsvpListColumns: [
                    "First Name, ",
                    "Last Name, ",
                    "Email"
                ],
                eventCommunicationMediums: [
                    "Live",
                    "Webinar"
                ],
                deleteList: deleteList,
                deleteResponderWithUndo: deleteResponderWithUndo,
                uploadList: uploadList,
                uploadRMEList: uploadRMEList,
                undoDeleteResponder: undoDeleteResponder,
                updateAppointmentKept: updateAppointmentKept,
                updateAppointmentSet: updateAppointmentSet,
                updateAttended: updateAttended,
                updateBuyingUnitType: updateBuyingUnitType,
                updateInsuranceClosed: updateInsuranceClosed,
                updateAumClosed: updateAumClosed,
                refreshCloseTotals: refreshCloseTotals,
                onDropLeaderMove: onDropLeaderMove,
                onDropChildMove: onDropChildMove,
                toggleSort: toggleSort,
                importListFromRmeApi: importListFromRmeApi,
                getRmeApiCampaigns: getRmeApiCampaigns,
                getRmeApiIsConnected: getRmeApiIsConnected,
                refreshRme: refreshRme,
                getRmeCampaignChanged: getRmeCampaignChanged,
                groupStagingList: [],
                hasSalesTrackerPermission: !!permissionService.hasOnePermission("SalesTracker:View")
            });

        //add/remove buying units to/from a staging list so they can be grouped later
        $ctrl.updateGroupStagingList = function (item) {
            if (item.toggleToGroup) {
                $ctrl.groupStagingList.push(item);

            } else {
                var index = $ctrl.groupStagingList.indexOf(item);
                if (index > -1) {
                    $ctrl.groupStagingList.splice(index, 1);
                }
            }
        };

        //several things to keep in mind when grouping:
        //1. leader.BuyingUnitLeaderId = leader.EventResponderId 
        //2. forEach child.BuyingUnitLeaderId = leader.EventResponderId 
        //3. forEach child.Children = push to leader.Children
        //4. forEach child.Children = []
        //5. forEach unit-turned-child, remove from $ctrl.buyingUnits
        //6. $ctrl.groupStagingList = [] in the end

        $ctrl.groupUnits = function () {
            //take the first-selected unit out of the staging list and set it as group leader
            var leader = $ctrl.groupStagingList.shift();
            var promises = [];
            leader.BuyingUnitLeaderId = leader.EventResponderId;


            $ctrl.groupStagingList.forEach(function (child) {
                var index = $ctrl.buyingUnits.indexOf(child);

                //if a group, process similar to above
                //however, we'd only need to update the group's UI, backend will attach its children to the new group leader
                if (child.Children) {
                    child.Children.forEach(function (subChild) {
                        subChild.BuyingUnitLeaderId = leader.EventResponderId;
                        leader.Children.push(subChild);
                        child.Children = [];
                    });
                }

                //update UI & put to backend
                //since user could group multiple large groups together, we're going to update the UI synchronously w/ the backend call to make the transition appear smoother
                if (index > -1) {
                    $ctrl.buyingUnits.splice(index, 1);
                    child.BuyingUnitLeaderId = leader.EventResponderId;
                    leader.Children.push(child);
                    child.toggleToGroup = false;
                    leader.toggleToGroup = false;

                    //this is where we make individual calls to the backend to update the buyingUnitLeaderId. We should move this to the backend
                    promises.push(marketingTrackerEventResponderApi.updateBuyingUnitLeader(child.EventGroupId,
                        child.EventResponderId,
                        child.BuyingUnitLeaderId)
                        //if fail, we revert the UI updates above w/ _getBuyingUnits()
                        .catch(function () {
                            _getBuyingUnits();
                            return figToaster.showSimple('Could not group these items together. Please try again.', "top", 'is-error');
                        }));
                }
            });

            //this updates the children's types to be the leader's
            $q.all(promises).then(function () {
                updateBuyingUnitType(leader.EventResponderId, leader.Type);
            });
            $ctrl.groupStagingList = [];
        };

        //several things to keep in mind when removing child from group
        //1. remove child from leader.Children
        //2. child.BuyingUnitLeaderId = null
        //3. add child back to $ctrl.buyingUnits
        //4. if only child in group, also set leader.BuyingUnitLeaderId = null

        $ctrl.removeFromGroup = function (leader, child) {
            var childIndex = leader.Children.indexOf(child);
            var leaderIndex = $ctrl.buyingUnits.indexOf(leader);
            child.removing = true;

            if (childIndex > -1 && leaderIndex > -1) {
                marketingTrackerEventResponderApi.updateBuyingUnitLeader(child.EventGroupId, child.EventResponderId, null)
                    .then(function () {
                        //remove child from the group 
                        leader.Children.splice(childIndex, 1);
                        //insert child into the spot after the leader's current index
                        $ctrl.buyingUnits.splice(leaderIndex + 1, 0, child);
                        //setting BuyingUnitLeaderId null will remove it from the group
                        child.BuyingUnitLeaderId = null;
                    })
                    //if fail, we revert the UI updates above w/ _getBuyingUnits()
                    .catch(function () {
                        _getBuyingUnits();
                        return figToaster.showSimple('Could not un-group item. Please try again.', "top", 'is-error');
                    })
                    .finally(function () {
                        child.removing = false;
                    });

                //if group only has one child, we turn the leader's BuyingUnitLeaderId to null to convert it to a single unit
                if (leader.Children.length === 1) {
                    leader.BuyingUnitLeaderId = null;
                    marketingTrackerEventResponderApi.updateBuyingUnitLeader(leader.EventGroupId, leader.EventResponderId, null).catch(function () {
                        _getBuyingUnits();
                        return figToaster.showSimple('Could not un-group item. Please try again.', "top", 'is-error');
                    })
                        .finally(function () {
                            child.removing = false;
                        });
                }
            }
        };

        function onDropLeaderMove(srcList, srcIndex, targetList, targetIndex) {
            // get item
            var item = srcList[srcIndex];

            // dropping onto existing buying unit
            // set BuyingUnitLeaderId to Leader
            var leader = targetList;

            // move children
            if (item.Children.length > 0) {
                _.forEach(item.Children,
                    function (child) {
                        child.BuyingUnitLeaderId = leader.EventResponderId;
                        leader.Children.push(child);
                    });
                item.Children = [];
            }

            item.BuyingUnitLeaderId = leader.EventResponderId;
            leader.Children.push(item);

            //update view (view will technically be out of sync w/ backend brielfy before _getBuyingUnits is called)
            srcList.splice(srcIndex, 1);
            marketingTrackerEventResponderApi.updateBuyingUnitLeader(item.EventGroupId, item.EventResponderId, item.BuyingUnitLeaderId)
                .catch(function () {
                    console.log('Failed to update leader move');
                })
                //Grab latest buying unit list to sync view & backend
                .finally(_getBuyingUnits);

            //srcList.splice(srcIndex, 1);

            // By returning true from dnd-drop we signal we already inserted the item.
            return true;
        }

        function onDropChildMove(srcList, srcIndex, targetList, targetIndex) {
            var movedItem = false;
            if (targetList !== srcList && targetIndex >= 0) {

                // get item
                var item = srcList.Children[srcIndex];

                if (targetList.EventResponderId) {
                    // dropping onto existing buying unit
                    // set BuyingUnitLeaderId to Leader
                    var leader = targetList;
                    item.BuyingUnitLeaderId = leader.EventResponderId;
                    leader.Children.push(item);
                } else {
                    // dropping onto no buying unit - becomes its own buying unit
                    // set BuyingUnitLeaderId to Null
                    item.BuyingUnitLeaderId = null;
                    targetList.push(item);
                }

                //update view (view will technically be out of sync w/ backend brielfy before _getBuyingUnits is called)
                srcList.Children.splice(srcIndex, 1);

                marketingTrackerEventResponderApi.updateBuyingUnitLeader(item.EventGroupId, item.EventResponderId, item.BuyingUnitLeaderId)
                    .catch(function () {
                        console.log('Failed to update child move');
                    })
                    //Grab latest buying unit list to sync view & backend
                    .finally(_getBuyingUnits);
                //srcList.Children.splice(srcIndex, 1);
                movedItem = true;
            }

            // By returning true from dnd-drop we signalize we already inserted the item.
            return movedItem;
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
            //$ctrl.buyingUnits = $filter('orderBy')($ctrl.buyingUnits, $ctrl.propertyName, $ctrl.reverseOrder);
            _sortBuyingUnits();
        }

        function _sortBuyingUnits() {
            $ctrl.buyingUnits = $filter('orderBy')($ctrl.buyingUnits, $ctrl.propertyName, $ctrl.reverseOrder);

            //sorting the buyingUnit list now sorts children within each group
            $ctrl.buyingUnits.forEach(function (unit) {
                if (unit.Children.length)
                    unit.Children = $filter('orderBy')(unit.Children, $ctrl.propertyName, $ctrl.reverseOrder);
            });
        }
        //Get event details object
        function _getEventDetails() {
            return marketingTrackerEventApi.getEventDetailed($stateParams.EventGroupId, $stateParams.EventId)
                .then(function (response) {
                    $ctrl.event = response;

                    //Format date obj for display
                    $ctrl.event.FormattedDate = moment($ctrl.event.EventDate).format('L');

                    //Edit obj to apply changes to a different ng-model than display obj.
                    //Useful for when user decides to cancel edit
                    $ctrl.eventEdit = ng.copy($ctrl.event);
                });
        }

        //Get event group object
        function _getEventGroup() {
            return marketingTrackerEventApi.getEventGroup($stateParams.EventGroupId)
                .then(function (response) {
                    $ctrl.eventGroup = response;

                    //Edit obj to apply changes to a different ng-model than display obj.
                    //Useful for when user decides to cancel edit
                    $ctrl.eventGroupEdit = ng.copy($ctrl.eventGroup);
                });
        }

        //Get performance timeline
        function _getPerformanceTimeline() {
            //reset array
            $ctrl.performanceArray = [];
            var collectionItem = eventPerformanceService.getCollectionItem($ctrl.event.EventType.Name);

            $ctrl.performanceArray.push(
                eventPerformanceService.getPerformanceItem(collectionItem.performanceArray, 'responseRate', $ctrl.event.ResponseRate),
                eventPerformanceService.getPerformanceItem(collectionItem.performanceArray, 'noShowRate', $ctrl.event.NoShowRate),
                eventPerformanceService.getPerformanceItem(collectionItem.performanceArray, 'appointmentSetRate', $ctrl.event.AppointmentSetRate),
                eventPerformanceService.getPerformanceItem(collectionItem.performanceArray, 'persistencyRate', $ctrl.event.PersistencyRate),
                eventPerformanceService.getPerformanceItem(collectionItem.performanceArray, 'closeRate', $ctrl.event.CloseRate),
                eventPerformanceService.getPerformanceItem(collectionItem.performanceArray, 'averageCaseSize', $ctrl.event.AverageCaseSize)
            );
        }
        
        //Get event responder list (aka buying units)
        function _getBuyingUnits() {
            return marketingTrackerEventBuyingUnitApi.getBuyingUnits($ctrl.EventGroupId)
                .then(function (response) {                    
                    $ctrl.buyingUnits = response;                    
                })
                .then(refreshCloseTotals)
                .catch(function (error) {
                    console.log("Error: Failed to get responder list", error);
                });
        }

        //Get event responder types/statuses
        function _getResponderTypes() {
            return marketingTrackerEventBuyingUnitApi.getTypes()
                .then(function (response) {
                    $ctrl.types = response;
                });
        }

        //get Spending Associated With Event
        function _getSpendingByEventGroupId() {
            return marketingTrackerSalesTrackerInputApi.getSpendingByEventGroupId($ctrl.EventGroupId).then(function (response) {
                $ctrl.test = '';
                $ctrl.spending = response;
            });
        }

        //Update event instance api call
        function _updateEvent(event) {
            return marketingTrackerEventGroupApi.updateEvent(event.EventGroupId, event.EventId, event);
        }

        //Update event group api call
        function _updateEventGroup(eventGroup) {
            return marketingTrackerEventGroupApi.update(eventGroup.Id, eventGroup);
        }
     
        //Update event group api separate calls for Attendees, UnitsAtteneded, AppointmentsSet, AppointmentsKept
        function _syncEventGroupMetrics() {

            //if autoSyncEventGroup has been fired agin within the 1.5 seconds of the last call, cancel last call and start timeout again
            $timeout.cancel($ctrl.autoSyncEventGroupMetrics);

            //autoSyncEventGroup is a timeout that waits 1.5 seconds after an event is fired to then calculate all the changes from the event and update the event group correspondingly
            $ctrl.autoSyncEventGroupMetrics = $timeout(function () {

                var getEvent = marketingTrackerEventApi.getEventDetailed($stateParams.EventGroupId, $stateParams.EventId);
                var getEventGroup = marketingTrackerEventApi.getEventGroup($stateParams.EventGroupId);

                $q.all([getEvent, getEventGroup]).then(function (results) {
                    var event = results[0];
                    var group = results[1];
                    var groupEdit = ng.copy(group);

                    groupEdit.UnitsAttended = {
                        Prospects: 0,
                        Clients: 0,
                        Referrals: 0,
                        Total: 0
                    };
                    groupEdit.Attendees = {
                        Prospects: 0,
                        Clients: 0,
                        Referrals: 0,
                        Total: 0
                    };
                    groupEdit.AppointmentsSet = {
                        Prospects: 0,
                        Clients: 0,
                        Referrals: 0,
                        Total: 0
                    };
                    groupEdit.AppointmentsKept = {
                        Prospects: 0,
                        Clients: 0,
                        Referrals: 0,
                        Total: 0
                    };
                    groupEdit.Reservations = {
                        Prospects: 0,
                        Clients: 0,
                        Referrals: 0,
                        Total: 0
                    };
                    groupEdit.AppointmentsClosed = {
                        Prospects: 0,
                        Clients: 0,
                        Referrals: 0,
                        Total: 0
                    };

                    _.forEach(event.BuyingUnits, function (unit) {

                        if (unit.Type === 'Prospect') {
                            groupEdit.Reservations.Prospects++;
                            groupEdit.Reservations.Total++;
                        }
                        if (unit.Type === 'Client') {
                            groupEdit.Reservations.Clients++;
                            groupEdit.Reservations.Total++;
                        }
                        if (unit.Type === 'Referral') {
                            groupEdit.Reservations.Referrals++;
                            groupEdit.Reservations.Total++;
                        }

                        if (unit.TotalClosed) {
                            if (unit.Type === 'Prospect') {
                                groupEdit.AppointmentsClosed.Prospects++;
                                groupEdit.AppointmentsClosed.Total++;
                            }
                            if (unit.Type === 'Client') {
                                groupEdit.AppointmentsClosed.Clients++;
                                groupEdit.AppointmentsClosed.Total++;
                            }
                            if (unit.Type === 'Referral') {
                                groupEdit.AppointmentsClosed.Referrals++;
                                groupEdit.AppointmentsClosed.Total++;
                            }
                        }

                        if (unit.Attended) {
                            if (unit.Type === 'Prospect') {
                                groupEdit.Attendees.Prospects++;
                                groupEdit.Attendees.Total++;
                            }
                            if (unit.Type === 'Client') {
                                groupEdit.Attendees.Clients++;
                                groupEdit.Attendees.Total++;
                            }
                            if (unit.Type === 'Referral') {
                                groupEdit.Attendees.Referrals++;
                                groupEdit.Attendees.Total++;
                            }
                        }

                        if (unit.Children.length > 0) {
                            _.forEach(unit.Children, function (child) {
                                if (child.Type === 'Prospect') {                                  
                                    groupEdit.Reservations.Prospects++;
                                    groupEdit.Reservations.Total++;
                                }
                                if (child.Type === 'Client') {                                  
                                    groupEdit.Reservations.Clients++;
                                    groupEdit.Reservations.Total++;
                                }
                                if (child.Type === 'Referral') {                                  
                                    groupEdit.Reservations.Referrals++;
                                    groupEdit.Reservations.Total++;
                                }

                                if (child.Attended) {
                                    if (child.Type === 'Prospect') {
                                        groupEdit.Attendees.Prospects++;
                                        groupEdit.Attendees.Total++;                                      
                                    }
                                    if (child.Type === 'Client') {
                                        groupEdit.Attendees.Clients++;
                                        groupEdit.Attendees.Total++;                                       
                                    }
                                    if (child.Type === 'Referral') {
                                        groupEdit.Attendees.Referrals++;
                                        groupEdit.Attendees.Total++;                                       
                                    }
                                }
                            });
                        }

                        if (unit.UnitAttended) {
                            if (unit.Type === 'Prospect') {
                                groupEdit.UnitsAttended.Prospects++;
                                groupEdit.UnitsAttended.Total++;
                            }
                            if (unit.Type === 'Client') {
                                groupEdit.UnitsAttended.Clients++;
                                groupEdit.UnitsAttended.Total++;
                            }
                            if (unit.Type === 'Referral') {
                                groupEdit.UnitsAttended.Referrals++;
                                groupEdit.UnitsAttended.Total++;
                            }
                        }

                        if (unit.AppointmentSet) {
                            if (unit.Type === 'Prospect') {
                                groupEdit.AppointmentsSet.Prospects++;
                                groupEdit.AppointmentsSet.Total++;
                            }
                            if (unit.Type === 'Client') {
                                groupEdit.AppointmentsSet.Clients++;
                                groupEdit.AppointmentsSet.Total++;
                            }
                            if (unit.Type === 'Referral') {
                                groupEdit.AppointmentsSet.Referrals++;
                                groupEdit.AppointmentsSet.Total++;
                            }
                        }

                        if (unit.AppointmentKept) {
                            if (unit.Type === 'Prospect') {
                                groupEdit.AppointmentsKept.Prospects++;
                                groupEdit.AppointmentsKept.Total++;
                            }
                            if (unit.Type === 'Client') {
                                groupEdit.AppointmentsKept.Clients++;
                                groupEdit.AppointmentsKept.Total++;
                            }
                            if (unit.Type === 'Referral') {
                                groupEdit.AppointmentsKept.Referrals++;
                                groupEdit.AppointmentsKept.Total++;
                            }
                        }
                    });

                    var promises = [];
                    if (!ng.equals(groupEdit.AppointmentsClosed, group.AppointmentsClosed)) {
                        //console.log('updateAppoitmentsClosed');
                        promises.push(marketingTrackerEventGroupApi.updateAppointmentsClosed(groupEdit.Id, groupEdit));
                    }
                    if (!ng.equals(groupEdit.Reservations, group.Reservations)) {
                        //console.log('updateReservations');
                        promises.push(marketingTrackerEventGroupApi.updateReservations(groupEdit.Id, groupEdit));
                    }
                    if (!ng.equals(groupEdit.Attendees, group.Attendees)) {
                        //console.log('updateAttendees');
                        promises.push(marketingTrackerEventGroupApi.updateAttendees(groupEdit.Id, groupEdit));
                    }
                    if (!ng.equals(groupEdit.UnitsAttended, group.UnitsAttended)) {
                        //console.log('updateUnitsAttended');
                        promises.push(marketingTrackerEventGroupApi.updateUnitsAttended(groupEdit.Id, groupEdit));
                    }
                    if (!ng.equals(groupEdit.AppointmentsSet, group.AppointmentsSet)) {
                        //console.log('updateAppointmentsSet');
                        promises.push(marketingTrackerEventGroupApi.updateAppointmentsSet(groupEdit.Id, groupEdit));
                    }
                    if (!ng.equals(groupEdit.AppointmentsKept, group.AppointmentsKept)) {
                        //console.log('updateAppointmentsKept');
                        promises.push(marketingTrackerEventGroupApi.updateAppointmentsKept(groupEdit.Id, groupEdit));
                    }

                    var updateGroup = false;
                    if (!ng.equals(group.TotalAumBusinessClosed, event.TotalAumBusinessClosed)) {
                        groupEdit.TotalAumBusinessClosed = event.TotalAumBusinessClosed;
                        updateGroup = true;
                    }

                    if (!ng.equals(group.TotalInsuranceBusinessClosed, event.TotalInsuranceBusinessClosed)) {
                        groupEdit.TotalInsuranceBusinessClosed = event.TotalInsuranceBusinessClosed;
                        updateGroup = true;
                    }

                    if (updateGroup) {
                        //console.log('updateEventGroup');
                        promises.push(marketingTrackerEventGroupApi.update(groupEdit.Id, groupEdit));
                    }

                    return $q.all(promises).then(function () {
                        //console.log('EventGroup Synced Successfully.');
                        updateGroup = false;
                        return;
                    }).catch(function (error) {
                        console.log("Update error:", error);
                    });
                });
            }, 1000);
        }

        function uploadList(file) {
            $ctrl.ui.isUploading = true;
            var payload = new FormData();
            payload.append("responderList", file);

            var message = "", toastClass = "";
            marketingTrackerEventResponderApi.postEventResponders($ctrl.eventGroup.Id, payload)
                .then(_getBuyingUnits)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(function (response) {
                    $ctrl.uploadDate = new Date();
                    var respondersAdded = _.reduce($ctrl.buyingUnits, function (result, buyingUnit) {
                        return result + 1 + buyingUnit.Children.length;
                    }, 0);
                    message = respondersAdded + " responders added.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    message = "Error: ", error.data;
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.isUploading = false;
                    amplitudeService.logClickEvent('Upload Responder List from PC');
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function uploadRMEList(file) {
            $ctrl.ui.isUploading = true;
            var payload = new FormData();
            payload.append("responderList", file);

            var message = "", toastClass = "";
            marketingTrackerEventResponderApi.postRMEEventResponders($ctrl.eventGroup.Id, payload)
                .then(_getBuyingUnits)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(function () {
                    $ctrl.uploadDate = new Date();
                    var respondersAdded = _.reduce($ctrl.buyingUnits, function (result, buyingUnit) {
                        return result + 1 + buyingUnit.Children.length;
                    }, 0);
                    message = respondersAdded + " responders added.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    message = "Error: ", error.data;
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.isUploading = false;
                    amplitudeService.logClickEvent('Upload RME Responder List from PC');
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function deleteList($event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this entire responder list? This action is permanent.",
                targetEvent: $event,
                ariaLabel: "Confirm list removal",
                ok: "Delete List",
                cancel: "Cancel",
                multiple: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm)
                .then(function () {
                    $ctrl.ui.isDeletingList = true;
                    var deletedTotal = $ctrl.buyingUnitInsights.Responders.length;
                    var message, toastClass;

                    marketingTrackerEventResponderApi.deleteAllResponders($stateParams.EventGroupId)
                        .then(function (result) {
                            toastClass = "is-success";
                            if (result.Deleted) {
                                message = result.Deleted + " responders removed.";
                            } else {
                                message = deletedTotal + " responders removed.";
                            }
                        })
                        .catch(function (error) {
                            console.log("Error: ", error.data);
                            if (error.Deleted) {
                                toastClass = "is-warning";
                                message = error.Deleted + " of " + error.Total + " responders removed.";
                            } else {
                                toastClass = "is-error";
                                message = "There was a problem updating your data. Please try again shortly.";
                            }
                        })
                        .finally(function () {
                            $ctrl.ui.isDeletingList = false;
                            $ctrl.ui.isUploading = false;
                            $ctrl.ui.isLoading = false;
                            figToaster.showSimple(message, "top", toastClass);
                            $ctrl.buyingUnits = [];
                            _getEventDetails()
                                .then(_getPerformanceTimeline)
                                .then(_getBuyingUnits)
                                .then(refreshCloseTotals);
                        });
                });
        }

        function _deleteResponder(responder) {

            var toastMessage = "", toastClass = "";
            marketingTrackerEventResponderApi.deleteResponderById(responder.EventGroupId, responder.EventResponderId)
                .then(function () {
                    var parms = [$ctrl.buyingUnitInsights.Responders, responder];
                    parms = parms.concat(responder.Children);

                    $ctrl.buyingUnitInsights.Responders = _.without.apply(null, parms);
                    $ctrl.buyingUnits = _.without($ctrl.buyingUnits, responder);

                    //toastMessage = "Responder deleted.";
                    //toastClass = "is-success";
                })
                .then(_getEventDetails)
                .then(refreshCloseTotals)
                .then(_syncEventGroupMetrics)
                .then(function () {
                    _getPerformanceTimeline();
                    toastMessage = "Buying Unit deleted.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    if (error.Deleted) {
                        toastClass = "is-warning";
                        toastMessage = error.Deleted + " of " + error.Total + " responders removed.";
                    } else {
                        toastClass = "is-error";
                        toastMessage = "There was a problem updating your data. Please try again shortly.";
                    }
                })
                .finally(function () {
                    responder.showUndo = false;
                    figToaster.showSimple(toastMessage, "top", toastClass);
                });
        }

        function deleteResponderWithUndo(responder) {
            responder.showUndo = true;
            responder.deferDelete = $timeout(function () {
                _deleteResponder(responder);
            }, 1800);


        }

        function undoDeleteResponder(responder) {
            $timeout.cancel(responder.deferDelete);
            responder.showUndo = false;
        }

        //function updateBuyingUnitType(buyingUnitLeaderId, type, children) {
        //    var promises = [];
        //    promises.push(marketingTrackerEventBuyingUnitApi.updateType($ctrl.EventGroupId, buyingUnitLeaderId, type));

        //    if (children.length > 0) {
        //        children.forEach(function (child) {
        //            child.Type = type;
        //            promises.push(marketingTrackerEventBuyingUnitApi.updateType($ctrl.EventGroupId, child.EventResponderId, type));
        //        });
        //    }
        //    $q.all(promises)
        //        .then(_getEventDetails)
        //        .then(_getPerformanceTimeline);
        //}

        function updateBuyingUnitType(buyingUnitLeaderId, type) {
            marketingTrackerEventBuyingUnitApi.updateType($ctrl.EventGroupId, buyingUnitLeaderId, type)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(_syncEventGroupMetrics);
        }

        function updateAttended(leader, child) {
            if (!child) {
                leader.Attended = !leader.Attended;

                if (!leader.Children)
                    leader.UnitAttended = !leader.UnitAttended;
                else
                    leader.UnitAttended = leader.Attended || leader.Children.some(function (child) { return child.Attended === true; });

                marketingTrackerEventResponderApi.updateAttended($ctrl.EventGroupId, leader.EventResponderId, leader.Attended)
                    .then(_getEventDetails)
                    .then(_getPerformanceTimeline)
                    .then(_syncEventGroupMetrics)
                    .catch('Failed to update leaders attendance status');
            }

            if (child) {
                child.Attended = !child.Attended;

                if (child.Attended)
                    child.UnitAttended, leader.UnitAttended = child.Attended;

                else
                    child.UnitAttended, leader.UnitAttended = leader.Attended || leader.Children.some(function (child) { return child.Attended === true; });

                marketingTrackerEventResponderApi.updateAttended($ctrl.EventGroupId, child.EventResponderId, child.Attended)
                    .then(_getEventDetails)
                    .then(_getPerformanceTimeline)
                    .then(_syncEventGroupMetrics)
                    .catch('Failed to update childs attendance status');
            }

        }

        function updateAppointmentSet(buyingUnitLeaderId, appointmentSet, buyingUnitLeaderFullName) {
            marketingTrackerEventBuyingUnitApi.updateAppointmentSet($ctrl.EventGroupId, buyingUnitLeaderId, appointmentSet, buyingUnitLeaderFullName)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(_syncEventGroupMetrics)
                .then(function () {
                    if ($ctrl.hasSalesTrackerPermission && appointmentSet) $ctrl.openAddOpportunityModal(buyingUnitLeaderFullName);
                 });
        }

        function updateAppointmentKept(buyingUnitLeaderId, value) {
            marketingTrackerEventBuyingUnitApi.updateAppointmentKept($ctrl.EventGroupId, buyingUnitLeaderId, value)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(_syncEventGroupMetrics)
        }

        function updateInsuranceClosed(buyingUnitLeaderId, value) {
            marketingTrackerEventBuyingUnitApi.updateInsuranceClosed($ctrl.EventGroupId, buyingUnitLeaderId, value)
                .then($ctrl.refreshCloseTotals())
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(_syncEventGroupMetrics);
        }

        function updateAumClosed(buyingUnitLeaderId, value) {
            marketingTrackerEventBuyingUnitApi.updateAumClosed($ctrl.EventGroupId, buyingUnitLeaderId, value)
                .then($ctrl.refreshCloseTotals())
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(_syncEventGroupMetrics);
        }

        function refreshCloseTotals() {
            $ctrl.buyingUnitInsights.InsuranceClosedTotal = 0;
            $ctrl.buyingUnitInsights.AumClosedTotal = 0;
            $ctrl.buyingUnitInsights.InsuranceClosedCount = 0;
            $ctrl.buyingUnitInsights.AumClosedCount = 0;
            $ctrl.buyingUnitInsights.Responders = [];
   
            _.forEach($ctrl.buyingUnits, function (unit) {

                $ctrl.buyingUnitInsights.Responders.push(unit);
                _.forEach(unit.Children, function (child) {
                    child.Children = [];
                    $ctrl.buyingUnitInsights.Responders.push(child);
                });

                if (unit.InsuranceClosed > 0) {
                    $ctrl.buyingUnitInsights.InsuranceClosedCount++;
                    $ctrl.buyingUnitInsights.InsuranceClosedTotal += parseFloat(unit.InsuranceClosed);
                }
                if (unit.AumClosed > 0) {
                    $ctrl.buyingUnitInsights.AumClosedCount++;
                    $ctrl.buyingUnitInsights.AumClosedTotal += parseFloat(unit.AumClosed);
                }
            });

            return $ctrl.buyingUnitInsights;
        }

        //Toggle edit for event title card
        $ctrl.editEventTitleCard = function () {
            $ctrl.ui.editingEventTitleCard = true;
        };

        //Toggle edit for event overview card
        $ctrl.editEventOverview = function () {
            $ctrl.ui.editingEventOverview = true;
        };

        //Save changes for event title card
        $ctrl.updateEventTitleCard = function () {
            if ($ctrl.titleCardForm.$valid) {
                var toastMessage,
                    toastClass;

                //Check if changes were made for event instance
                if (!ng.equals($ctrl.eventEdit, $ctrl.event)) {
                    $ctrl.ui.loadingEventInfo = true;

                    //Reformat date obj back to ISO
                    $ctrl.eventEdit.EventDate = moment($ctrl.eventEdit.FormattedDate).utc();

                    _updateEvent($ctrl.eventEdit)
                        .then(function () {
                            _getEventDetails()
                                .then(function () {
                                    toastMessage = 'Changes saved.';
                                    toastClass = 'is-success';
                                })
                                .catch(function () {
                                    toastMessage = 'Changes could not be saved. Please try again..';
                                    toastClass = 'is-error';
                                })
                                .finally(function () {
                                    figToaster.showSimple(toastMessage, 'top', toastClass);
                                    $ctrl.ui.loadingEventInfo = false;
                                });
                        })
                        .then(_getPerformanceTimeline);
                }

                //Check if changes were made for event group
                if (!ng.equals($ctrl.eventGroupEdit, $ctrl.eventGroup)) {
                    $ctrl.ui.loadingEventInfo = true;

                    _updateEventGroup($ctrl.eventGroupEdit)
                        .then(function () {
                            _getEventGroup()
                                .then(function () {
                                    toastMessage = 'Changes saved.';
                                    toastClass = 'is-success';
                                })
                                .catch(function () {
                                    toastMessage = 'Changes could not be saved. Please try again..';
                                    toastClass = 'is-error';
                                })
                                .finally(function () {
                                    figToaster.showSimple(toastMessage, 'top', toastClass);
                                    $ctrl.ui.loadingEventInfo = false;
                                });
                        })
                        .then(_getEventDetails)
                        .then(_getPerformanceTimeline);
                }
            }
            $ctrl.ui.editingEventTitleCard = false;
        };

        //Save changes for event overview card
        $ctrl.updateEventOverview = function () {
            if ($ctrl.overviewForm.$valid) {
                var toastMessage,
                    toastClass;

                //Check if changes were made for event instance
                if (!ng.equals($ctrl.eventEdit, $ctrl.event)) {
                    $ctrl.ui.loadingEventOverview = true;

                    //Reformat date obj back to ISO
                    $ctrl.eventEdit.EventDate = moment($ctrl.eventEdit.FormattedDate).utc();

                    _updateEvent($ctrl.eventEdit)
                        .then(function () {
                            _getEventDetails()
                                .then(function () {
                                    toastMessage = 'Changes saved.';
                                    toastClass = 'is-success';
                                })
                                .catch(function () {
                                    toastMessage = 'Changes could not be saved. Please try again..';
                                    toastClass = 'is-error';
                                })
                                .finally(function () {
                                    figToaster.showSimple(toastMessage, 'top', toastClass);
                                    $ctrl.ui.loadingEventOverview = false;
                                });
                        })
                        .then(_getPerformanceTimeline);
                }
                //Check if changes were made for event group
                if (!ng.equals($ctrl.eventGroupEdit, $ctrl.eventGroup)) {
                    $ctrl.ui.loadingEventOverview = true;

                    _updateEventGroup($ctrl.eventGroupEdit)
                        .then(function () {
                            _getEventGroup()
                                .then(function () {
                                    toastMessage = 'Changes saved.';
                                    toastClass = 'is-success';
                                })
                                .catch(function () {
                                    toastMessage = 'Changes could not be saved. Please try again..';
                                    toastClass = 'is-error';
                                })
                                .finally(function () {
                                    figToaster.showSimple(toastMessage, 'top', toastClass);
                                    $ctrl.ui.loadingEventOverview = false;
                                });
                        })
                        .then(_getEventDetails)
                        .then(_getPerformanceTimeline);
                }
            }
            $ctrl.ui.editingEventOverview = false;
        };

        $ctrl.openAddSpendingFromEventModal = function () {
            $mdDialog.show(
                {
                    controller: "addSpendingController",
                    controllerAs: "$ctrl",
                    templateUrl: "App/Tools/MarketingTrackerNew/Components/AddSpending/add-spending.component.html",
                    bindToController: true,
                    eventName: $ctrl.event.Title,
                    eventCost: $ctrl.eventGroup.TotalEventCost,
                    eventDate: $ctrl.allEvents[0].EventDate,
                    eventGroupId: $ctrl.eventGroup.Id,
                    ancillaryEventGroupId: null
                })
                .then(function (spending) {
                    $ctrl.spending = spending;
                })
        }

        function getRmeApiIsConnected() {
            return marketingTrackerRMEApi.getCustomerRecord()
                .then(function (response) {
                    $ctrl.ui.showRmeApiSection = true;
                })
                .catch(function (error) {
                    //console.log("Error: ", error);
                    $ctrl.ui.showRmeApiSection = false;
                });
        }

        function getRmeApiCampaigns() {
            $ctrl.ui.loadingCampaignList = true;
            return marketingTrackerRMEApi.getCustomerCampaigns(moment().set(rmeCampaignStartDate).format(), moment().format())
                .then(function (response) {
                    $ctrl.rmeCampaignsFromApi = response;
                    $ctrl.ui.loadingCampaignList = false;
                })
                .catch(function (error) {
                    console.log("Error: ", error.data);
                    $ctrl.ui.loadingCampaignList = false;
                });
        }

        //get active rme campaign when import list from api
        function _getActiveRmeCampaign() {
            $ctrl.activeRmeCampaign = _.find($ctrl.rmeCampaignsFromApi,
                function (campaign) {
                    return campaign.CampaignId === $ctrl.selectedRmeCampaignId;
                });
        }

        function _getActiveRmeCampaignEvent() {
            $ctrl.activeRmeCampaignEvent = _.find($ctrl.rmeCampaignEventsFromApi,
                function (event) {
                    return event.EventId === $ctrl.selectedRmeCampaignEventId;
                });
        }

        function getRmeCampaignChanged() {
            $ctrl.rmeCampaignEventsFromApi = null;
            $ctrl.selectedRmeCampaignEventId = null;
            _getRmeCampaignEvents();
        }

        function _getRmeCampaignEvents() {
            return marketingTrackerRMEApi.getCustomerCampaignEvents($ctrl.selectedRmeCampaignId, moment().set(rmeCampaignStartDate).format(), moment().format())
                .then(function (response) {
                    $ctrl.rmeCampaignEventsFromApi = response;
                })
                .catch(function (error) {
                    console.log("Error: ", error.data);
                });
        }

        function importListFromRmeApi(rmeCampaignId, rmeCampaignEventId) {
            $ctrl.ui.isUploading = true;
            var message = "", toastClass = "";
            marketingTrackerEventGroupApi.postEventRespondersFromRmeApiV2($ctrl.EventGroupId, rmeCampaignId, rmeCampaignEventId, moment().set(rmeCampaignStartDate).format(), moment().format())
                .then(_getBuyingUnits)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(function (response) {
                    $ctrl.uploadDate = new Date();
                    var respondersAdded = _.reduce($ctrl.buyingUnits, function (result, buyingUnit) {
                        return result + 1 + buyingUnit.Children.length;
                    }, 0);
                    message = respondersAdded + " responders added.";
                    toastClass = "is-success";
                })
                .then(_getActiveRmeCampaign)
                .then(_getActiveRmeCampaignEvent)
                .catch(function (error) {
                    console.log("Error: ", error.data);
                    message = "There was a problem importing your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    if ($ctrl.orderedList) {
                        setPage(1);
                    }
                    $ctrl.ui.isUploading = false;
                    amplitudeService.logClickEvent('Import Responder List from RME API');
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function _getEventGroupRmeCampaign() {
            return marketingTrackerEventGroupApi.getEventGroupRmeCampaign($ctrl.EventGroupId)
                .then(function (result) {
                    $ctrl.selectedRmeCampaignId = result.CampaignId;
                    $ctrl.selectedRmeCampaignEventId = result.RmeCampaignEventId;
                })
                .catch(function () {
                    $ctrl.selectedRmeCampaignId = null;
                    $ctrl.selectedRmeCampaignEventId = null;
                });
        }

        function _getAllEventsInEventGroup() {
            marketingTrackerEventGroupApi.getEvents($ctrl.EventGroupId).then(function (response) {
                $ctrl.allEvents = response.sort(function (a, b) {
                    return a.EventDate.localeCompare(b.EventDate);
                });
            });
        }

        function refreshRme() {
            $ctrl.ui.isUploading = true;
            var oldBuyingUnitsCount = _.reduce($ctrl.buyingUnits,
                function (result, buyingUnit) {
                    return result + 1 + buyingUnit.Children.length;
                },
                0);
            marketingTrackerEventGroupApi.refreshEventRespondersFromRmeApiV2($ctrl.EventGroupId, moment().set(rmeCampaignStartDate).format(), moment().format())
                .then(_getBuyingUnits)
                .then(_getEventDetails)
                .then(_getPerformanceTimeline)
                .then(function (response) {
                    $ctrl.uploadDate = new Date();
                    var respondersAdded = _.reduce($ctrl.buyingUnits, function (result, buyingUnit) {
                        return result + 1 + buyingUnit.Children.length;
                    }, 0) - oldBuyingUnitsCount;
                    message = respondersAdded + " responders added.";
                    toastClass = "is-success";
                })
                .then(_getActiveRmeCampaign)
                .then(_getActiveRmeCampaignEvent)
                .catch(function (error) {
                    console.log("Error: ", error.data);
                    message = "There was a problem refreshing your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    if ($ctrl.orderedList) {
                        setPage(1);
                    }
                    $ctrl.ui.isUploading = false;
                    amplitudeService.logClickEvent('Refresh Responder List from RME API');
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        $ctrl.openAddOpportunityModal = function(name) {
            $mdDialog.show(
                {
                    controller: "addOpportunityController",
                    controllerAs: "$ctrl",
                    templateUrl: "App/Tools/MarketingTrackerNew/Components/AddOpportunity/add-opportunity.component.html",
                    bindToController: true,
                    clientName: name
                })
        }

        $ctrl.$onInit = function () {
            $ctrl.EventGroupId = $stateParams.EventGroupId;
            $ctrl.EventId = $stateParams.EventId;
            $ctrl.propertyName = 'LastName';
            $ctrl.reverseOrder = false;

            var promises = [];

            //Add promise to each api call
            promises.push(_getEventDetails());
            promises.push(_getEventGroup());
            promises.push(_getResponderTypes());
            promises.push(_getBuyingUnits());
            promises.push($ctrl.getRmeApiIsConnected());
            promises.push(_getSpendingByEventGroupId());
            promises.push(_getAllEventsInEventGroup());
            promises.push(_getEventGroupRmeCampaign());

            $q.all(promises)
                .then(_sortBuyingUnits)
                .then(_getPerformanceTimeline)
                .then(function () {
                    if ($ctrl.ui.showRmeApiSection) {
                        $ctrl.getRmeApiCampaigns()
                            .then(_getActiveRmeCampaign)
                            .then(_getRmeCampaignEvents)
                            .then(_getActiveRmeCampaignEvent);
                    }
                })
                .catch(function () {
                    var toastMessage = 'Could not load event information. Please try again.';
                    var toastClass = 'is-error';
                    figToaster.showSimple(toastMessage, 'top', toastClass);
                })
                .finally(function () {
                    //Toggle global data loading only on init
                    //Subsequent loading toggle will be per-section (ie. loadingOverview, etc.)

                    $ctrl.ui.loadingData = false;
                });         
        };

        $ctrl.donOpenUpload = function (event) {
            event.stopImmediatePropagation()
        }
    }
})(window.app, window.angular); // jshint ignore:line